import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'madero-confirm-waiting-list-exit-dialog',
    templateUrl: './confirm-waiting-list-exit-dialog.component.html',
    styleUrl: './confirm-waiting-list-exit-dialog.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatDialogModule, MatButtonModule, TranslatePipe],
})
export class ConfirmWaitingListExitDialogComponent {}
